export default "__VITE_ASSET__pFJD7mn1__"